import { SurveyTemplateEnum } from "../services/zeos-api/enums/Survey";

export type ExploreSurveyDomainSlug =
  | "power-generation"
  | "building-performance"
  | "battery-storage"
  | "ev-charging"
  | "carbon-emissions"
  | "demand-response";

export type ExploreSurveyNavSlug = ExploreSurveyDomainSlug;

export interface IExploreSurveyDomainConfig {
  slug: ExploreSurveyDomainSlug;
  templateId: SurveyTemplateEnum;
  title: string;
  breadcrumb: string;
  summaryTitle: string;
  summaryBody: string;
}

export interface IExploreSurveyNavItem {
  slug: ExploreSurveyNavSlug;
  title: string;
}

/** Domain tabs shown on every Explore survey (matches PowerGen chrome). */
export const EXPLORE_SURVEY_NAV_ITEMS: IExploreSurveyNavItem[] = [
  { slug: "power-generation", title: "Power Generation" },
  { slug: "building-performance", title: "Building Performance" },
  { slug: "ev-charging", title: "EV Charging" },
  { slug: "battery-storage", title: "Battery Status" },
  { slug: "carbon-emissions", title: "Carbon Emissions" },
  { slug: "demand-response", title: "Demand Response" },
];

export const EXPLORE_SURVEY_DOMAINS: IExploreSurveyDomainConfig[] = [
  {
    slug: "power-generation",
    templateId: SurveyTemplateEnum.PowerGen,
    title: "Power Generation",
    breadcrumb: "Explore > Power Generation > Survey",
    summaryTitle: "Survey complete",
    summaryBody:
      "Thanks for sharing your priorities. We’ll use this to tailor the recommendations for this property.",
  },
  {
    slug: "building-performance",
    templateId: SurveyTemplateEnum.BuildingPerformance,
    title: "Building Performance",
    breadcrumb: "Explore > Building Performance > Survey",
    summaryTitle: "Your Building Performance profile is ready",
    summaryBody:
      "Thanks for sharing your priorities. We’ll use this to tailor the building performance pathway for this property.",
  },
  {
    slug: "battery-storage",
    templateId: SurveyTemplateEnum.BatteryStorage,
    title: "Battery Storage",
    breadcrumb: "Explore > Battery Storage > Survey",
    summaryTitle: "Your Battery Storage profile is ready",
    summaryBody:
      "Thanks for sharing your objectives and constraints. We’ll use this to identify the most appropriate battery pathway.",
  },
  {
    slug: "ev-charging",
    templateId: SurveyTemplateEnum.EvCharging,
    title: "EV Charging",
    breadcrumb: "Explore > EV Charging > Survey",
    summaryTitle: "Your EV Charging profile is ready",
    summaryBody:
      "Thanks for sharing your charging needs. We’ll use this to recommend the right deployment and monitoring pathway.",
  },
  {
    slug: "carbon-emissions",
    templateId: SurveyTemplateEnum.CarbonEmissions,
    title: "Carbon Emissions",
    breadcrumb: "Explore > Carbon Emissions > Survey",
    summaryTitle: "Your Carbon Emissions profile is ready",
    summaryBody:
      "Thanks for sharing your carbon priorities. We’ll use this to establish the right boundary and next reporting steps.",
  },
  {
    slug: "demand-response",
    templateId: SurveyTemplateEnum.DemandResponse,
    title: "Demand Response",
    breadcrumb: "Explore > Demand Response > Survey",
    summaryTitle: "Your Demand Response profile is ready",
    summaryBody:
      "Thanks for sharing your flexibility preferences. No load has been committed and no control action has been authorized.",
  },
];

export const exploreSurveyConfigBySlug = (
  slug: string | undefined
): IExploreSurveyDomainConfig | undefined =>
  EXPLORE_SURVEY_DOMAINS.find((domain) => domain.slug === slug);

export const exploreSurveyIntentPath = (
  exploreSlug: string,
  domainSlug: ExploreSurveyNavSlug
) => `/${exploreSlug}/${domainSlug}/intent`;

export const exploreSurveyGoalsPath = (
  exploreSlug: string,
  domainSlug: ExploreSurveyNavSlug
) => `/${exploreSlug}/${domainSlug}/goals`;
